import type { PlanningContext } from './PlanningContext';
import type { ValidatorReport } from '../../TacticalPlan/ValidatorReport';
import { OpenHours } from '../../Vehicles/OpenHours/OpenHours';
import { readonlyMode } from '../../../../stores/store';
import { get } from 'svelte/store';

export class PlanningValidator {
    public checkIfAllVehiclesAreDispatchedInAssignments(
        report: ValidatorReport,
        context: PlanningContext
    ) {
        const vehicles = context.getContext().vehicles;
        const assignments = context.getContext().assignments;
        const scenario = context.getContext().scenario;

        const vehicleIds = vehicles
            .filter(
                vehicle =>
                    vehicle.open_hours && OpenHours.isOpenThisDay(vehicle.open_hours, scenario.day)
            )
            .map(vehicle => vehicle.id);
        const assignedVehicleIds = assignments.map(assignment => assignment.getVehicleId());

        const notAssignedVehicleIds = vehicleIds.filter(
            vehicleId => !assignedVehicleIds.includes(vehicleId)
        );
        if (notAssignedVehicleIds.length > 0 && !get(readonlyMode)) {
            report.addWarning(
                null,
                'Niektóre pojazdy nie są uwzględnione w tym planowaniu - przelicz ponownie plan taktyczny, aby je uwzględnić.',
                null
            );
        }
    }
}
